import { render, staticRenderFns } from "./returnCar.vue?vue&type=template&id=5648aae2&scoped=true&"
import script from "./returnCar.vue?vue&type=script&lang=js&"
export * from "./returnCar.vue?vue&type=script&lang=js&"
import style0 from "./returnCar.vue?vue&type=style&index=0&id=5648aae2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5648aae2",
  null
  
)

export default component.exports